<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'settings.api.createToken' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="onCancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <app-loading *ngIf="isLoading"></app-loading>

    <form [formGroup]="form" *ngIf="!isLoading && !createdToken" class="create-token-form">
      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{ 'settings.api.tokenName' | translate }}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="name" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['name'])">{{ 'fieldRequired' | translate }}</mat-error>
        </mat-form-field>
      </div>
      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{ 'settings.api.expiresInLabel' | translate }}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput type="number" min="1" formControlName="expiresIn" [placeholder]="'settings.api.expiresInPlaceholder' | translate">
        </mat-form-field>
        <p class="create-token-help">{{ 'settings.api.expiresInHelp' | translate }}</p>
      </div>
    </form>

    <div *ngIf="!isLoading && createdToken" class="create-token-form">
      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{ 'settings.api.generatedToken' | translate }}</label>
        <mat-form-field appearance="outline" class="token-field" subscriptSizing="dynamic">
          <input matInput [value]="createdToken.key" readonly>
          <button mat-icon-button matSuffix color="primary" type="button" (click)="copyTokenToClipboard()" [disabled]="copied">
            <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <p class="create-token-warning">{{ 'settings.api.generatedTokenWarning' | translate }}</p>
    </div>
  </div>

  <footer class="app-dialog__footer" *ngIf="!isLoading && !createdToken">
    <button mat-stroked-button type="button" (click)="onCancel()">{{ 'cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="onCreate()">{{ 'save' | translate }}</button>
  </footer>

  <footer class="app-dialog__footer" *ngIf="!isLoading && createdToken">
    <button mat-stroked-button type="button" (click)="onCancel()">{{ 'cancel' | translate }}</button>
  </footer>
</div>
